/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 1f61193df12d67d7b57107e1f742f23a6d8baaea95bb123b0e58db93afa8e34e
 */
import {
  base_colorContentBorder,
  white100,
} from 'ext-ui/style/colors'
import {
  nav_desktop_navContainerItemsVSpacing,
  nav_desktop_navContainerVSpacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  background: ${white100};
  border-right-color: ${base_colorContentBorder};
  border-right-style: solid;
  border-right-width: 1px;
  display: flex;
  flex-direction: column;
  gap: ${nav_desktop_navContainerItemsVSpacing};
  height: 100%;
  padding-block: ${nav_desktop_navContainerVSpacing};
  transition: width 300ms cubic-bezier(0, 0, 0.58, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &.not-minimized {
    align-items: flex-start;
    width: 232px;
  }

  &.minimized {
    align-items: center;
    width: 40px;
  }
`
